import { render, staticRenderFns } from "./SettlementDialog.vue?vue&type=template&id=357e4499"
import script from "./SettlementDialog.vue?vue&type=script&lang=js"
export * from "./SettlementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports